<template>
  <v-row>
    <v-col cols="12" offset-lg="1" lg="10">
      <v-breadcrumbs divider=">" :items="breadcrumbs" class="pl-1 pb-3" />
      <v-card class="mb-1">
        <v-card-title class="theme">
          <v-icon large class="white--text">keyboard</v-icon>
          <span class="headline ml-2 white--text">Add Backoffice document</span>
          <v-spacer />
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-form ref="form" v-model="formValidation">
            <v-container>
              <v-row>
                <v-col cols="12" lg="6">
                  <v-text-field
                    label="Name*"
                    :rules="[validationRules.required]"
                    persistent-hint
                    hint="Name of the backoffice Document"
                    v-model="backoffice.name"
                  />
                </v-col>
                <v-col cols="12" lg="6">
                  <v-autocomplete
                    label="Type"
                    persistent-hint
                    hint="Select a category or use general"
                    :items="types"
                    :rules="[validationRules.required]"
                    item-text="name"
                    item-value="value"
                    v-model="backoffice.type"
                  />
                </v-col>
                <v-col cols="12" lg="12">
                  <div class="my-5 ">
                    <ckeditor
                      :editor="editor"
                      :config="editorConfig"
                      v-model="backoffice.description"
                      style="min-height: 300px !important"
                    />
                  </div>
                </v-col>
              </v-row>
              <v-btn
                depressed
                class="save rounded-sm white--text mt-5 mx-7"
                @click="save"
                >Save</v-btn
              >
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>

    <v-snackbar v-model="snackbar" :bottom="true" :right="true">
      {{ snackbarMessage }}
      <v-btn color="pink" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-row>
</template>

<script>
import BalloonEditor from "@ckeditor/ckeditor5-editor-balloon/src/ballooneditor";
import {mapGetters} from "vuex";

import {Actions} from "@/views/actions";
import {Breadcrumbs} from "@/views/breadcrumbs";
import {Component} from "@/views/component";
import {Constants} from "@/views/constants";

export default {
  name: Component.Protected.Backoffice.Add,
  data: () => ({
    editor: BalloonEditor,
    breadcrumbs: Breadcrumbs.Backoffice.Add,
    backoffice: {
      type: "",
      name: "",
      description: "",
      visibility: "",
    },
    modal: false,
    types: Constants.BackOffice.Types.Obj,
    formValidation: true,
    editorConfig: {},
  }),
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    save() {
      if (!this.backoffice.description) {
        this.snackbarMessage = "please provide description"
        this.snackbar = true
        return
      }
      if (this.$refs.form.validate()) {
        const data = {
          name: this.backoffice.name,
          description: this.backoffice.description,
          type: this.backoffice.type,
        };

        this.$store
            .dispatch(Actions.Backoffice.Add, data)
            .then(() => {
              this.$router.push({name: Component.Protected.Backoffice.List});
            })
          .catch((e) => {
            console.error(Constants.BackOffice.Messages.Error.Add, e);
            this.snackbar = true;
            this.snackbarMessage = Constants.BackOffice.Messages.Error.Add;
          });
      }
    },
  },
  created() {
    if (!this.userInfo || !this.userInfo.role) {
      this.$store.dispatch(Actions.Firebase.UserInfo);
    }
    this.editorConfig = this.editorConfigBackoffice;
  },
};
</script>
<style>
* >>> div.v-picker__title {
  background-color: #551738 !important;
  border-color: #551738 !important;
}

* >>> div.v-date-picker-table {
  height: 200px !important;
}
:root {
  --ck-color-focus-border: lightgray;
}
.ck.ck-editor__editable > .ck-placeholder::before {
  color: lightgray !important;
}
.ck.ck-editor__editable_inline > :first-child {
  margin-top: var(--ck-spacing-large);
  padding-bottom: var(--ck-spacing-large) !important;
  font-family: Roboto Slab;
}
.ck.ck-editor__editable_inline > :last-child {
  margin-top: var(--ck-spacing-large);
}
.ck-content {
  color: #272929;
}
.ck-focused {
  border: thin solid lightgray !important;
  outline: none !important;
  box-shadow: none !important;
}
@media (max-width: 768px) {
    .ck-content:h1 {
        font-size: 20px;
    }
    .ck-content:h2{
      font-size: 18px
    }
     .ck-content{
      padding:0.5rem!important;
    }
}
@media (min-width: 769px) and (max-width: 1024px) {
    .ck-content:h1 {
        font-size: 22px;
    }
    .ck-content:h2{
      font-size: 20px;
    }
}
</style>